import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Connection {
  id: string;
  name: string;
  avatar: string;
  location: string;
  crops: string[];
  score: number;
  isFollowing: boolean;
  connectedAt: string;
}

export interface Post {
  id: string;
  userId: string;
  userName: string;
  userAvatar: string;
  content: string;
  photos: string[];
  likes: number;
  comments: number;
  isLiked: boolean;
  createdAt: string;
}

interface NetworkStore {
  connections: Connection[];
  posts: Post[];
  addConnection: (connection: Connection) => void;
  removeConnection: (id: string) => void;
  toggleFollow: (id: string) => void;
  addPost: (post: Post) => void;
  toggleLike: (postId: string) => void;
  clearNetwork: () => void;
}

export const useNetworkStore = create<NetworkStore>()(
  persist(
    (set) => ({
      connections: [],
      posts: [],

      addConnection: (connection) =>
        set((state) => ({
          connections: [connection, ...state.connections],
        })),

      removeConnection: (id) =>
        set((state) => ({
          connections: state.connections.filter((conn) => conn.id !== id),
        })),

      toggleFollow: (id) =>
        set((state) => ({
          connections: state.connections.map((conn) =>
            conn.id === id ? { ...conn, isFollowing: !conn.isFollowing } : conn
          ),
        })),

      addPost: (post) =>
        set((state) => ({
          posts: [post, ...state.posts],
        })),

      toggleLike: (postId) =>
        set((state) => ({
          posts: state.posts.map((post) =>
            post.id === postId
              ? {
                  ...post,
                  isLiked: !post.isLiked,
                  likes: post.isLiked ? post.likes - 1 : post.likes + 1,
                }
              : post
          ),
        })),

      clearNetwork: () => set({ connections: [], posts: [] }),
    }),
    {
      name: 'network-storage',
    }
  )
);
